// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3ogUq","itemTitle":"ClientEmergencyInfo_itemTitle__3-cBx","itemText":"ClientEmergencyInfo_itemText__1-biv"};